Ext.define('SA.view.combolocation.CreateCombinationLocation', {
    alias: 'widget.create-combination-location',
    extend: 'SA.view.combolocation.CombinationLocationWindow',

    title: 'Create Combination Location',

    initComponent() {
        var locationSeries = this.locationSeries;

        this.callParent();

        if (locationSeries) {
            this.locationsList.setLocations(locationSeries);
        }
    },

    save() {
        var locationsList = this.locationsList,
            name = this.getNameFieldValue(),
            censusRelease = this.getCensusRelease(),
            locationSeries = locationsList.getLocations();

        this.setLoading('Saving…');

        SA.Ajax.request({
            method: 'create',
            resource: 'user/customLocations',

            data: [{
                censusRelease,
                locationSeries,
                name,
                type: 'combination'
            }],

            success: locations => {
                var combo = locations[0];

                SA.data.CustomLocations.add(combo);

                Ext.callback(this.callback, this.scope, [combo]);

                this.destroy();
            }
        });
    }
});
